<template>
  <v-container fill-height fluid>
    <v-slide-y-reverse-transition mode="out-in">
      <!-- Show the correspondent view to the current route -->
      <router-view />
    </v-slide-y-reverse-transition>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState([
      "currentClassification",
      "loadingClassifications"
    ])
  },
  methods: {
    ...mapActions(["getClassifications", "setCurrentClassification"]),
    /**
     * Set the current classification if there is no one or the route param is different
     * from the one in the store.
     */
    setCurrentClassificationFromRoute() {
      const noCurrentClassification = !this.currentClassification;
      const currentId = this.currentClassification
        ? this.currentClassification.id
        : undefined;
      const routeId = this.$route.params.classificationId;
      if (noCurrentClassification || currentId !== routeId) {
        this.setCurrentClassification(routeId);
      }
    }
  },
  created() {
    if (!this.loadingClassifications) {
      this.setCurrentClassificationFromRoute();
    }
  },
  watch: {
    loadingClassifications() {
      if (!this.loadingClassifications) {
        this.setCurrentClassificationFromRoute();
      }
    }
  }
};
</script>
